import { render, staticRenderFns } from "./YearChart.vue?vue&type=template&id=238bf65a&scoped=true"
import script from "./YearChart.vue?vue&type=script&lang=js"
export * from "./YearChart.vue?vue&type=script&lang=js"
import style0 from "./YearChart.vue?vue&type=style&index=0&id=238bf65a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238bf65a",
  null
  
)

export default component.exports